import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { IClient } from '@techspert-io/clients';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { EnrichedUserCreateTemplate } from '../../models/user.models';
import { UserTemplatePipe } from '../../pipes/user-template.pipe';
import { SelectUserTemplateComponent } from '../select-user-template/select-user-template.component';
import { UserFormComponent } from '../user-form/user-form.component';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
  imports: [MaterialModule, SelectUserTemplateComponent, UserFormComponent],
  providers: [UserTemplatePipe],
})
export class CreateUserComponent {
  @Input() clients: IClient[];

  @Output() createUserSignal = new EventEmitter<string>();

  @ViewChild('stepper') private stepper: MatStepper;

  isSubmitting = false;

  selectedTemplate: EnrichedUserCreateTemplate;

  get titleText() {
    return [
      'Create',
      this.selectedTemplate && this.stepper.selectedIndex === 1
        ? this.userTemplatePipe
            .transform(this.selectedTemplate.type)
            .toLowerCase()
        : 'user',
    ].join(' ');
  }

  constructor(private userTemplatePipe: UserTemplatePipe) {}

  selectTemplate(template: EnrichedUserCreateTemplate) {
    this.selectedTemplate = template;

    this.stepper.next();
  }

  handleIsSubmitting(isSubmitting: boolean) {
    this.isSubmitting = isSubmitting;
  }

  createUser(userId: string) {
    this.createUserSignal.emit(userId);
  }
}
